// extracted by mini-css-extract-plugin
export default {"medium":"form-dialog_medium__w5pOa","dialog_sm":"form-dialog_dialog_sm__76tKX"};